import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { FabricationPurchaseOrderService } from '../../../../../../services/FabricationPurchaseOrder';
import { Button } from '@gerdau/hefesto/Button';
import { Icon } from '@gerdau/hefesto/Icon';
import { Banner } from '@gerdau/hefesto/Banner';
import { getTaggingInformationScreen } from '../../../../../../utils/Tagging';
import { sendTagging } from '../../../../../../store/ducks/tagging/actions';
import { BannerContainer } from './styles';
interface IOptionsColumnProps {
  orderId: number;
  contractNumber: string;
}

const OptionsColumn: React.FC<IOptionsColumnProps> = ({
  orderId,
  contractNumber
}) => {
  const [pdfState, setPdfState] = useState({ loading: false, error: false });

  const dispatch = useDispatch();
  const { location } = useHistory();

  const onClickDownloadPDF = () => {
    setPdfState({ loading: true, error: false });

    FabricationPurchaseOrderService.downloadPurchaseOrderPDF(orderId)
      .then((fabricationPurchaseOrderBase64) => {
        const pdfFileName = `Pedido_${contractNumber}_${orderId}`;

        const dataurl =
          'data:text/plain;base64,' + fabricationPurchaseOrderBase64;
        const element = document.createElement('a');
        element.setAttribute('href', dataurl);
        element.setAttribute('download', `${pdfFileName}.pdf`);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        setPdfState({ loading: false, error: false });
      })
      .catch((err) => {
        console.error(err);
        setPdfState({ loading: false, error: true });
      });
  };

  const { screenName = '', itemDescription = '' } = getTaggingInformationScreen(
    location.pathname,
    true
  );

  return (
    <OrderResumeDownload
      onClickResume={() => {
        onClickDownloadPDF();
        dispatch(
          sendTagging({
            screenName,
            page: location.pathname,
            itemName: 'button:resumo_do_pedido',
            itemDescription: `${itemDescription}_resumoDoPedido`,
            event: 'click'
          })
        );
      }}
      loading={pdfState.loading}
      error={pdfState.error}
    />
  );
};

interface IOrderResumeDownloadProps {
  onClickResume(): void;
  loading: boolean;
  error: boolean;
}

const OrderResumeDownload: React.FC<IOrderResumeDownloadProps> = ({
  onClickResume,
  loading,
  error
}) => {
  const [closeErrorBanner, setCloseErrorBanner] = useState(true);
  const dispatch = useDispatch();
  const { screenName = '', itemDescription = '' } = getTaggingInformationScreen(
    location.pathname,
    true
  );

  const taggingErrorDownloadResume = (err: boolean) => {
    err &&
      dispatch(
        sendTagging({
          screenName,
          page: location.pathname,
          itemName: 'error:baixar_resumo_pedido',
          itemDescription: `${itemDescription}_erroBaixarResumoPedido`,
          event: 'error',
          nonInteraction: true
        })
      );
  };

  useEffect(() => {
    taggingErrorDownloadResume(error);
  }, [error]);

  return (
    <>
      <Button
        type="button"
        variant="tertiary"
        name="button-download"
        onClick={onClickResume}
        loading={loading}
        disabled={loading}
        icon={<Icon option="Download" />}
      >
        Resumo do pedido
      </Button>
      {error && closeErrorBanner && (
        <BannerContainer>
          <Banner
            bannerWithIcon
            handleActionOne={() => setCloseErrorBanner(false)}
            labelActionOne="Fechar"
            text="Erro ao tentar baixar o resumo do pedido"
            variant="danger"
          />
        </BannerContainer>
      )}
    </>
  );
};

export default OptionsColumn;
